import { builder } from '@builder.io/react';
import { configs } from './constants';

// Custom components
import '../components/builder-components';

builder.init(configs.BUILDER_PUBLIC_API_KEY);
